import { httpClient } from '../http/httpClient'
import { UserRoleEnum } from './user'

export async function userChangRole(id: string, role: UserRoleEnum) {
  const { data } = await httpClient.patch(`/user/${id}/changeRole`, {
    role,
  })

  return data
}
